/* eslint-disable no-undef */
import { endpoints } from "//www.cluedupp.com/cdn/shop/t/122/assets/config.js?v=80138251624765561951680185824";

export const debounce = (method, delay) => {
  clearTimeout(method._tId);
  method._tId = setTimeout(function () {
    method();
  }, delay);
}

export const triggerEvent = (el, event, key) => {
  let eventObj;

  // Cross browser solution to dispatching an event and keycode
  if(document.createEventObject) {
    eventObj = document.createEventObject();
    eventObj.keyCode = key;
    el.fireEvent(`on${event}`, eventObj);
  } else if(document.createEvent) {
    eventObj = document.createEvent("Events");
    eventObj.initEvent(event, true, true);
    eventObj.which = key;
    eventObj.keyCode = key;
    el.dispatchEvent(eventObj);
  }
};

export const isHidden = el => el.offsetParent === null;

export const smoothScroll = (hash) => {
  if (hash === '#') {
    return;
  }

  const target = document.querySelector(hash) || document.querySelector(`#shopify-section-${hash.substr(1)}`);

  if (!target) {
    return;
  }

  const yOffset = -100;
  const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;

  // const headerOffset = 80; // Magic number oops
  // const elementPosition = target.offsetTop;
  // const offsetPosition = elementPosition - headerOffset;

  window.scrollTo({
    top: y,
    behavior: "smooth",
  });
}

export const smoothScrollElem = (target) => {
  if (!target) {
    return;
  }

  const yOffset = -100;
  const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;

  // const headerOffset = 80; // Magic number oops
  // const elementPosition = target.offsetTop;
  // const offsetPosition = elementPosition - headerOffset;

  window.scrollTo({
    top: y,
    behavior: "smooth",
  });
}

export const animateValue = (obj, end, toFixed = 0) => {
  let startTimestamp = null;
  const start = 0;
  const step = (timestamp) => {
    if (!startTimestamp) {
      startTimestamp = timestamp;
    }
    const progress = Math.min((timestamp - startTimestamp) / 750, 1);
    obj.textContent = `${Number((progress * (end - start)) + start).toFixed(toFixed)}k`;
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};
export const getPreviousSibling = (elem, selector) => {
  // Get the next sibling element
  let sibling = elem.previousElementSibling;

  // If there's no selector, return the first sibling
  if (!selector) {
    return sibling;
  }

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches(selector)) {
      return sibling;
    }
    sibling = sibling.previousElementSibling;
  }
};
export const getNextSibling = (elem, selector) => {
  // Get the next sibling element
  let sibling = elem.nextElementSibling;

  // If there's no selector, return the first sibling
  if (!selector) {
    return sibling;
  }

  // If the sibling matches our selector, use it
  // If not, jump to the next sibling and continue the loop
  while (sibling) {
    if (sibling.matches(selector)) {
      return sibling;
    }
    sibling = sibling.nextElementSibling;
  }
};
export const escapeHtml = (text) => text
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
  .replace(/'/g, "&#039;");

export const handleize = function (str) {
  str = str.toLowerCase();

  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
    str = str.replace(/-+z/, "");
  }

  if (str.charAt(0) == "-") {
    str = str.replace(/A-+/, "");
  }

  return str
};

export const renderTemplate = (result, template, placement = '') => {
  const eventTemplate = template.content.cloneNode(true);
  const parent = document.createElement("div");
  const addressLine1 = result.address_line_1.toLowerCase();
  const logoWidth = 250;
  const switchTemplate = template.classList.contains('is-modal');
  const soldOut = result.address_line_2 === 'SOLD OUT';
  let eventLogo;
  let eventTile;
  let logoAspectRatio;

  parent.append(eventTemplate);
  const eventLink = parent.querySelector('[data-event-link]');
  let dateEvent = soldOut ? result.city : result.address_line_2;
  const city = soldOut ? result.city.split(', ').slice(1).join(', ') : result.city;
  const soldOutInner = `
    <div class="bt-Button_Inner">
      SOLD OUT
    </div>`;

  eventLink.setAttribute(
    "href",
    escapeHtml(result.website.replace(mttd.variables.storeURLHardcoded, ""))
  );
  eventLink.dataset.eventDateString = escapeHtml(dateEvent);
  eventLink.classList.add("keen-slider__slide");
  parent.querySelector('[data-event-address]').innerHTML = `${escapeHtml(city)}, ${escapeHtml(result.country)}`;

  if (switchTemplate) {
    const dateSplit = dateEvent.split(' ');
    let month = dateSplit[1];
    let day = dateSplit[0];
    let remaining = Math.floor(Math.random() * 6);

    if (result.country === 'USA' || result.country === 'Puerto Rico') {
      month = dateSplit[0];
      day = dateSplit[1];
    }

    if (soldOut) {
      eventLink.innerHTML = soldOutInner;
      parent.querySelector('[data-bogof-text]').textContent = 'SOLD OUT';
      remaining = 0;
    }

    const dateEventCard = `<span class="evt-EventStockist_Month">${month.substr(0, 3)}</span><span class="evt-EventStockist_Day">${parseInt(day, 10)}</span>`;
    parent.firstElementChild.classList.add('is-modal');
    parent.querySelector('[data-event-date]').innerHTML = dateEventCard;
    parent.querySelector('.evt-Bogof').dataset.remaining = remaining;

  } else {
    if (soldOut && dateEvent.includes(',')) {
      dateEvent = dateEvent.split(',')[0];

      if (parent.querySelector('.bt-Button')) {
        parent.querySelector('.bt-Button').innerHTML = soldOutInner;
      }
    }

    parent.querySelector('[data-event-date]').innerHTML = escapeHtml(dateEvent);

    for (const [key, logo] of Object.entries(mttd.variables.eventLogos)) {
      let searchKey = key;

      // TODO Would be an idea to switch to collections and use the product within
      // TODO collection URL for Stockist to give more consistency to the search key
      // TODO switch searchKey to use text from customiser
      if (key === 'dd') {
        searchKey = 'detective';
      } else if (key === 'csd') {
        searchKey = 'csi';
      }

      if (addressLine1.includes(searchKey)) {
        // Pulls logo and event tile from the theme customiser settings
        eventLogo = logo.images.small;
        logoAspectRatio = logo.aspect_ratio;
        eventTile = mttd.variables.eventTiles[key];
        break;
      }
    }

    if (parent.querySelector('[data-event-logo]')) {
      parent.querySelector('[data-event-logo]').alt = escapeHtml(result.name);
      parent.querySelector('[data-event-logo]').src = eventLogo;
      parent.querySelector('[data-event-logo]').width = logoWidth;
      parent.querySelector('[data-event-logo]').height = Math.ceil(logoWidth / logoAspectRatio);
    }
    if (parent.querySelector('[data-event-image]')) {
      parent.querySelector('[data-event-image]').dataset.bgset = eventTile;
    }
  }

  if (placement !== '') {
    parent.querySelector('.evt-EventStockist').classList.add(`evt-EventStockist-${placement}`, `evt-EventStockist-${placement}`);
  }

  return parent.innerHTML;
};

export const capitalise = (string) => {
  return (typeof string === 'string') ? string.charAt(0).toUpperCase() + string.slice(1) : '';
};

export const camelise = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (Number(match) === 0) {
      // or if (/\s+/.test(match)) for white spaces
      return "";
    }
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
};

export const pascalcase = (str) => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match) => {
    if (Number(match) === 0) {
      // or if (/\s+/.test(match)) for white spaces
      return "";
    }
    return match.toUpperCase();
  });
};

export const formatItem = (item) => {
  return `clueduppUser${capitalise(item)}`;
};

// export const getGeoData = async () => {
//   const geoipDetails = await fetch(endpoints.geoip).then((response) => response.json()).catch((error) => {
//     console.error('GeoIP fetch error: ', error);
//     return false;
//   });

//   return geoipDetails;
// };
export const getGeolocation = async (address) => {
  const geolocation = await fetch(endpoints.positionStack(address)).then((response) => response.json()).catch((error) => {
    console.error('Geolocation fetch error: ', error);
    return false;
  });

  return geolocation.data[0];
};

function handleErrors(res) {
  if (!res.ok) throw new Error(res.error);
  return res;
}

export const getLatLng = async () => {
  let response;

  await fetch(endpoints.ipapi)
    .then(handleErrors)
    .then(res => res.json())
    .then(res => response = res)
    .catch(err => console.error(err));

  return response;
}
export const subscribe = (listId, email, params = {}) => {
  const config = Object.assign({}, params, {
    g: listId,
    email,
  });

  const body = Object.keys(config).reduce((str, key) => {
    str.append(key, config[key]);
    return str;
  }, new URLSearchParams());

  return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
    method: 'POST',
    headers: {
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
    },
    body,
  }).then((res) => res.json());
};

export const handleLinkTracking = (category, target, title) => {
  if (!category || !target) return;

  ga('send', 'event', {
    eventCategory: category,
    eventAction: 'click',
    eventLabel: target,
    title
  });
}

export default {
  animateValue,
  getPreviousSibling,
  getNextSibling,
  isHidden,
  escapeHtml,
  renderTemplate,
  capitalise,
  formatItem,
  handleLinkTracking,
  // getGeoData,
  getGeolocation,
  smoothScroll,
  subscribe,
  triggerEvent,
};
